import { FormControl } from "@mui/material";
import darkColors from "assets/theme-dark/base/colors";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import pxToRem from "assets/theme/functions/pxToRem";
import rgba from "assets/theme/functions/rgba";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';



const { size } = typography;
const { borderRadius } = borders;


const MDSelect = ({
    theme,
    isDisabled = false,
    value,
    name,
    options,
    onChange,
    placeholder = "Selecione...",
    isMulti = false,
    creatable = false,
    ...rest }) => {
    const [controller, dispatch] = useMaterialUIController();
    const { darkMode } = controller;

    const { transparent, inputBorderColor, white, grey } = darkMode ? darkColors : colors;
    
    const SelectComponent = creatable ? CreatableSelect : Select;

    return (
        <FormControl fullWidth>
            <SelectComponent
                {...rest}
                closeMenuOnSelect={true}
                name={name}
                value={value}
                options={options}
                onChange={onChange}
                isDisabled={isDisabled}
                placeholder={placeholder}
                isMulti={isMulti}
                noOptionsMessage={() => "Nenhuma opção"}
                loadingMessage={() => "Carregando..."}
                menuPortalTarget={document.body} // <-- aqui é o segredo
                styles={{
                    control: (styles, state) => {
                        const disabledBg = darkMode ? grey[800] : grey[200];
                        const disabledText = darkMode ? white.main : grey[600];
                        const disabledBorder = darkMode ? grey[700] : grey[300];

                        return {
                            ...styles,
                            backgroundColor: state.isDisabled ? disabledBg : transparent.main,
                            color: state.isDisabled ? disabledText : (darkMode ? white.main : grey[800]),
                            borderColor: state.isDisabled ? disabledBorder : rgba(inputBorderColor, darkMode ? 0.6 : 1),
                            opacity: 1,
                            pointerEvents: state.isDisabled ? "none" : "auto",
                            fontSize: size.xs,
                            minHeight: pxToRem(30),
                            height: 'auto',
                            paddingTop: 0,
                            paddingBottom: 0,
                            borderRadius: borderRadius.md,
                        };
                    },
                    singleValue: (styles) => ({
                        ...styles,
                        color: darkMode ? white.main : grey[800],
                    }),
                    placeholder: (styles) => ({
                        ...styles,
                        color: grey[darkMode ? 400 : 600],
                    }),
                    input: (styles) => ({
                        ...styles,
                        color: darkMode ? white.main : grey[800],
                        padding: 0,
                        margin: 0,
                    }),
                    option: (styles, { isDisabled, isFocused, isSelected }) => {
                        return {
                            ...styles,
                            fontSize: size.xs,
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                            color: isSelected ? '#ffffff' : (darkMode ? white.main : grey[800]),
                            backgroundColor: isSelected 
                                ? '#2196f3' 
                                : isFocused 
                                ? (darkMode ? '#5D616D' : '#e3f2fd') 
                                : (darkMode ? '#4B4F5C' : '#ffffff'),
                            padding: `${pxToRem(6)} ${pxToRem(10)}`,
                            '&:active': {
                                backgroundColor: isSelected ? '#2196f3' : '#bbdefb'
                            }
                        };
                    },
                    valueContainer: (styles) => ({
                        ...styles,
                        padding: `0 ${pxToRem(8)}`,
                    }),
                    dropdownIndicator: (styles) => ({
                        ...styles,
                        padding: pxToRem(4),
                    }),
                    clearIndicator: (styles) => ({
                        ...styles,
                        padding: pxToRem(4),
                    }),
                    menu: (styles) => ({
                        ...styles,
                        backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                        zIndex: 9999,
                    }),
                    menuList: (styles) => ({
                        ...styles,
                        backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        </FormControl>

    )
};

MDSelect.propTypes = {
    isDisabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    isMulti: PropTypes.bool
};

export default MDSelect
